(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shoes-menu-cards"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const tab = event.target.closest('[data-shoes-tab-control]');
    if (!tab) return;

    const menu = tab.closest('[data-shoes-mobile-menu]');
    if (!menu) return;

    const panelId = tab.getAttribute('aria-controls');

    menu.querySelectorAll('[data-shoes-tab-control]').forEach((item) => {
      const isSelected = item === tab;
      item.classList.toggle('is-active', isSelected);
      item.setAttribute('aria-selected', isSelected ? 'true' : 'false');
    });

    menu.querySelectorAll('[data-shoes-tab-panel]').forEach((panel) => {
      panel.hidden = panel.id !== panelId;
    });
  });
  } catch(e) { console.error(e); }
})();

})();
